<template>
  <div class="accordion" :style="{ color: fontColor }">
    <div
      v-for="(contentRow, index) in accordion"
      :key="index"
      class="accordion"
    >
      <button
        v-track="{ tracking: contentRow.tracking, label: contentRow.heading }"
        class="accordion__heading"
        :class="{ 'accordion__heading--focus-inverted': focusInverted }"
        :aria-controls="'accordion-panel-' + index"
        :aria-expanded="isAccordionOpen(contentRow.open) ? 'true' : 'false'"
        @click="showContent(index)"
      >
        <span :id="contentRow.id" class="anchor-target"></span>
        <h4>
          {{ contentRow.heading }}

          <i
            class="icon icon-open"
            :class="isAccordionOpen(contentRow.open) ? 'open-icon' : ''"
          ></i>
        </h4>
      </button>
      <AccordionTransition :key="'panel-' + index">
        <div
          v-show="isAccordionOpen(contentRow.open)"
          :id="'accordion-panel-' + index"
          class="accordion__content"
          :aria-labelledby="'accordion-panel-' + index"
        >
          <template v-if="!contentRow.text">
            <slot />
          </template>
          <Article
            v-else-if="contentRow.text.content"
            :text-content="contentRow.text"
            no-margin
            class="accordion__text"
            @skip-to-account="$emit('skipToAccount')"
            @skip-to-payment="$emit('skipToPayment')"
          />
          <template v-else>
            <p class="accordion__text">
              {{ contentRow.text }}
            </p>
          </template>
        </div>
      </AccordionTransition>
      <hr />
    </div>
  </div>
</template>

<script>
import Article from "./Article"
import AccordionTransition from "./AccordionTransition"
import stubDirectives from "../mixins/stubDirectives"

export default {
  components: {
    Article,
    AccordionTransition
  },
  mixins: [stubDirectives],
  props: {
    accordionContent: {
      type: Array,
      default: () => []
    },
    fontColor: {
      type: String,
      default: null
    },
    multiSlot: {
      type: Object,
      default: () => {}
    },
    multiSlotIndex: {
      type: Number,
      default: null
    },
    isActiveMulti: {
      type: Boolean,
      default: false
    },
    focusInverted: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      accordion: []
    }
  },
  computed: {
    isMultiSlot() {
      return this.multiSlot && Object.keys(this.multiSlot).length > 0
        ? true
        : false
    }
  },
  watch: {
    "$route.hash": function(id) {
      const indexFound = this.accordionContent.findIndex(
        item => `#${item.id}` === id
      )
      if (indexFound > -1) {
        this.showContent(indexFound)
      }
    }
  },
  mounted() {
    this.accordionSlots()
  },
  methods: {
    isAccordionOpen(isOpen) {
      return this.isMultiSlot ? this.isActiveMulti : isOpen
    },
    accordionSlots() {
      if (this.isMultiSlot) {
        this.multiSlot.index = this.multiSlotIndex
        this.accordion.push(this.multiSlot)
      } else {
        this.accordion = this.accordionContent
      }
    },
    showContent(index) {
      let itemIndex, accordion
      this.isMultiSlot
        ? (itemIndex = this.multiSlot.index)
        : (itemIndex = index)
      this.isMultiSlot
        ? (accordion = this.accordionContent)
        : (accordion = this.accordion)

      accordion.map((contentRow, i) => {
        itemIndex === i
          ? (accordion[itemIndex].open = !accordion[itemIndex].open)
          : (contentRow.open = false)
        return contentRow
      })

      if (this.isMultiSlot) {
        this.$emit("click-accordion", itemIndex)
      }
    }
  }
}
</script>

<style lang="scss">
.accordion {
  width: 100%;

  &__heading {
    background: none;
    border: none;
    width: 100%;
    text-align: left;
    padding: $spacing-4 $spacing-5 $spacing-4 0;
    font-weight: bold;
    position: relative;
    color: inherit;
    cursor: pointer;
    letter-spacing: -0.32px;

    @include sm {
      padding-right: $spacing-8;
    }

    @include lg {
      padding: $spacing-6 $spacing-8 $spacing-6 0;
    }

    &:focus {
      outline: 0;
      &:not(:active) {
        box-shadow: 0 0 0 0.125em $focus;
      }
    }

    &--focus-inverted {
      &:focus:not(:active) {
        box-shadow: 0 0 0 0.125em $focus-inverted;
      }
    }
  }

  .icon-open {
    font-weight: bold;
    font-size: $size-7;
    position: absolute;
    top: $spacing-4;
    right: 0;
    transition: transform 0.3s ease-in-out;
    top: 50%;
    margin-top: -0.5em;

    @include lg {
      font-size: $size-6;
    }
  }

  &__text {
    padding: 0 0 $spacing-4 0;
    max-width: 710px;

    @include xs {
      padding: 0 $spacing-5 $spacing-4 0;
    }
    @include sm {
      padding: 0 0 $spacing-4 0;
    }
  }

  .open-icon {
    transform: rotate(45deg);
    transition: transform 0.3s ease-in-out;
  }

  hr {
    background-color: $night;
    height: 1px;
    margin: 0;
  }
}
</style>
